<template>
  <ElForm
    :model="teamMember"
    :rules="formRules"
    ref="team-member-form"
    label-position="top"
    label-width="120px"
    status-icon
    @submit.native.prevent
  >
<!--    @submit.native.prevent="onFormSubmit"-->
    <ElFormItem
      v-if="isAddForm"
      prop="email"
    >
      <template slot="label">
        Login <span class="font-normal text-sm">(Email)</span>
      </template>
      <ElInput
        ref="input-email"
        v-model="teamMember.email"
        name="email"
        placeholder="name@example.com"
        autocomplete="username"
      />
    </ElFormItem>
    <!--
      The password field is gone. The owner used to type their colleague's password here,
      which meant we had to keep a readable copy of it to show back on the team card, and
      it encouraged handing the same password to everyone on the door. Eventor now issues
      a single-use password, shows it once after the invitation and emails it to the member.
    -->
    <p
      v-if="isAddForm"
      class="text-sm text-primary-light mb-20"
    >
      Eventor will create a single-use password for this person and email it to them. You
      will see it once after you add them, so you can pass it on yourself if you prefer.
    </p>
    <ElFormItem
      label="Name"
      prop="name"
    >
      <ElInput
        v-model="teamMember.name"
        placeholder="Member name"
        class="w-auto"
      />
    </ElFormItem>
    <ElFormItem
      label="Role"
      prop="role"
    >
      <ElSelect
        v-model="teamMember.role"
        placeholder="Select a role"
      >
        <ElOption
          v-for="option in roleOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        />
      </ElSelect>
    </ElFormItem>
    <ElFormItem
      v-if="teamMember.role === 'eventPromoter'"
      label="Max. guests"
      prop="maxGuests"
    >
      <ElInputNumber
        v-model="teamMember.maxGuests"
        :min="0"
      />
    </ElFormItem>
    <slot :submitForm="onFormSubmit" />
  </ElForm>
</template>

<script>
const defaultTeamMemberFields = {
  name: '',
  email: '',
  role: 'guestsCheckIn', // guestsFullAccess, guestsCheckIn, eventPromoter
  maxGuests: 0,
};

export default {
  props: {
    existingTeamMember: {
      type: Object,
    },
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!value || value === '') {
        callback('Please enter a member name');
      }
      callback();
    };
    const validateEmail = (rule, value, callback) => {
      const re = /^.+@.+\..+$/;

      if (!value || value.length === 0) {
        callback('Please enter your Email');
      } else if (!re.test(value) || value.length >= 256 || value.includes(' ')) {
        callback('Please enter a valid Email');
      }
      callback();
    };
    return {
      formRules: {
        name: [{
          validator: validateName,
          trigger: 'blur',
        }],
        email: [{
          validator: validateEmail,
          trigger: 'blur',
        }],
      },
      roleOptions: [{ // TODO: One source for the roles options/values
        label: 'Guest check-in/out only',
        value: 'guestsCheckIn',
      }, {
        label: 'Manager',
        value: 'guestsFullAccess',
      }],
      // 'eventPromoter' is hidden from the picker for now (2026-09-13); existing promoter members keep working
      teamMember: { ...defaultTeamMemberFields },
    };
  },
  watch: {
    existingTeamMember: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.teamMember = { ...defaultTeamMemberFields };
          return;
        }

        const {
          name, email, role, maxGuests,
        } = value;

        this.teamMember = {
          name: name || defaultTeamMemberFields.name,
          email: email || defaultTeamMemberFields.email,
          role: role || defaultTeamMemberFields.role,
          maxGuests: maxGuests || defaultTeamMemberFields.maxGuests,
        };
      },
    },
  },
  computed: {
    isAddForm() {
      return !this.existingTeamMember;
    },
  },
  methods: {
    async onFormSubmit() {
      const formIsValidated = await this.$refs['team-member-form']
        .validate()
        .then((v) => v)
        .catch((v) => v);
      if (!formIsValidated) return;

      const { maxGuests, ...restOfFields } = this.teamMember;
      const teamMember = {
        ...restOfFields,
        ...(this.teamMember.role === 'eventPromoter' && { maxGuests }), // Add maxGuests if member is eventPromoter
      };

      this.$emit('submit', teamMember);
    },
    focusFirstInputField() {
      if (this.existingMemberDetails || !this.$refs['input-email']) return;
      this.$nextTick(() => {
        this.$refs['input-email'].focus();
      });
      // this.$refs['input-email'].focus();
      // console.log(this.$refs['input-email']);
    },
    resetForm() {
      this.$refs['team-member-form'].resetFields();
      this.$refs['team-member-form'].clearValidate();
    },
  },
};
</script>

<style scoped>

</style>
